// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__CY95d","overlay":"Hero_overlay__BXfaI","content":"Hero_content__RAs46","videoBackground":"Hero_videoBackground__uTQRJ","box":"Hero_box__GePBB"};